import React from 'react'
import Button from 'lib/ui/Button'
import {now} from 'lib/date-time'
import {useNiftyFiftyUpdate} from 'Event/template/NiftyFifty'
import {generateHashId} from 'lib/crypto/hash'

export default function AddAgendaButton(props: {
  className?: string
  nextPosition: number
}) {
  const {nextPosition} = props
  const save = useNiftyFiftyUpdate()

  const addAgenda = () => {
    generateHashId([
      'niftyfifty_',
      'agenda_item_',
      new Date().valueOf().toString(),
      Math.random().toString(),
    ]).then((id) => {
      save({
        agendaList: {
          items: {
            [id]: {
              text: 'Event',
              description: '',
              startDate: now(),
              endDate: now(),
              link: null,
              isVisible: true,
              speakers: [],
              position: nextPosition,
              rules: [],
            },
          },
        },
      })
    })
  }

  return (
    <Button
      size="large"
      variant="contained"
      color="secondary"
      fullWidth
      aria-label="add agenda event"
      onClick={addAgenda}
      className={props.className}
    >
      Add Agenda Event
    </Button>
  )
}
